export default __webpack_public_path__ + "static/media/900-1000.e592b1ea.jpg";